import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, formatApiError } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const user = await login(email, password);
      toast.success(`Welcome back, ${user.name}`);
      nav(user.role === "admin" ? "/admin" : "/account");
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || e.message);
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="login-page" className="max-w-md mx-auto px-6 py-24">
      <div className="overline">Sign in</div>
      <h1 className="serif text-4xl mt-3">Welcome back.</h1>
      <form onSubmit={submit} className="mt-10 space-y-6">
        <div><div className="fld-label">Email</div><input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="fld mt-2" /></div>
        <div><div className="fld-label">Password</div><input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="fld mt-2" /></div>
        {err && <div className="text-xs text-red-700">{err}</div>}
        <button data-testid="login-submit" disabled={loading} className="btn-primary w-full justify-center">{loading ? "Signing in…" : "Sign in"}</button>
      </form>
      <div className="text-center text-xs text-[#5A5A5A] mt-6">
        New here? <Link to="/register" className="text-[#0A0A0A] underline" data-testid="goto-register">Create an account</Link>
      </div>
    </div>
  );
}
